export const responsiveness = (small: any, medium: any, large: any): any =>
  window.innerWidth < 600 ? small : window.innerWidth < 900 ? medium : large;

export const isIOS = (): boolean =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

const isMacOS = (): boolean =>
  navigator.platform.toUpperCase().includes('MAC');

export const isSafari = (): boolean =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && isMacOS();

export const formatBranding = (text: string): string =>
  text
    .replace(
      /ChatGPT|Chatgpt|chatgpt|CHATGPT|Assistant|Asistente|asistente|Assistentin|Assistent|assistante|assistant|assistentin|assistent/g,
      'Retzia'
    )
    .replace(/OpenAI|openai|openAI|Openai/g, 'Retz');
